// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1Fu3_","upload":"Small_upload__3TtrJ","imageWrap":"Small_imageWrap__zWUvd","removeBtn":"Small_removeBtn__1vrhi"};